// import React, { useCallback, useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { useDispatch } from "react-redux";
// import { logout } from '../../features/auth/authSlice.js'
// import SkeletonLoader from "../../components/skeletonLoader.jsx";
// import CircularSegmentProgress from "../../components/circularProgress.jsx";
// import SvgIcon from "../../assest/svg/svg.jsx";
// import ProgressBar from "../../components/progressBar.jsx";
// // import LineChart from "../../components/Charts/lineChart.jsx";

// const DashboardCourses = ({ dir }) => {
//   // const [courses, setCourses] = useState([]);
//   // const [stats, setStats] = useState(null);
//   const [learningStats, setLearningStats] = useState(null);
//   const [modules, setModules] = useState([]); // NEW STATE for modules
//   // const [loading, setLoading] = useState(true);
//   const [loadingModules, setLoadingModules] = useState(true); // NEW state for module loading
//   // const [loadingCertificates, setLoadingCertificates] = useState(false); // NEW state for module loading
//   const [certificates, setCertificates] = useState(false)
//   const base_url = process.env.REACT_APP_LMS_APP_BASE_URL;
//   const token = localStorage.getItem("token");
//   const profileData = JSON.parse(localStorage.getItem("profileData"));
//   const departmentId = profileData?.department?.id || null;
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const dispatch = useDispatch()

//   const handleSignOut = useCallback(() => {
//     localStorage.removeItem("user");
//     localStorage.removeItem("token");
//     localStorage.removeItem("profileData");
//     sessionStorage.removeItem("conversation");
//     sessionStorage.removeItem("currentSessionId");
//     sessionStorage.removeItem("sessionNumber");
//     sessionStorage.removeItem("sessions");
//     dispatch(logout())
//     navigate("/login");
//   }, [navigate, dispatch]);

//   // const fetchCourses = useCallback(async () => {
//   //   try {
//   //     const response = await axios.get(
//   //       `${base_url}/user/courses/dashboard`,
//   //       {
//   //         headers: {
//   //           Authorization: `Bearer ${token}`,
//   //         },
//   //       }
//   //     );
//   //     const data = response.data?.data || {};
//   //     setStats(data.stats || {});
//   //   } catch (error) {
//   //     if (error?.response?.status === 401) {
//   //       handleSignOut();
//   //     }
//   //     console.error("Error fetching dashboard data:", error);
//   //   }
//   // }, [token, base_url, handleSignOut]);

//   const fetchLearningStats = useCallback(async () => {
//     try {
//       const response = await axios.get(
//         `${base_url}/user/user-stats/dashboard`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const data = response.data?.data || {};
//       setLearningStats(data || {});
//     } catch (error) {
//       if (error?.response?.status === 401) {
//         handleSignOut();
//       }
//       console.error("Error fetching dashboard data:", error);
//     }
//   }, [token, base_url, handleSignOut]);

//   const fetchModules = useCallback(async () => {
//     const moduleTypes = [
//       { type: 'onboarding', param: 'onboarding' },
//       { type: 'onjobtraining', param: 'on-job-training' },
//     ];
//     try {
//       const requests = moduleTypes.map((item) =>
//         axios.get(
//           `${base_url}/admin/${item.type}/modules/get-department-modules/${departmentId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//             params: { type: item.param }, // ✅ FIX HERE
//           }
//         )
//       );
//       const responses = await Promise.all(requests);
//       const allModules = responses.flatMap((res) => res.data?.data?.department?.modules || []);
//       setModules(allModules);
//     } catch (error) {
//       if (error?.response?.status === 401) {
//         handleSignOut();
//       }
//       console.error('Error fetching department modules:', error);
//     } finally {
//       setLoadingModules(false);
//     }
//   }, [token, departmentId, base_url, handleSignOut]);

//   const fetchCertificates = useCallback(async () => {
//     try {
//       const res = await fetch(`${base_url}/certificate/my-certificates`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       if (!res.ok) throw new Error("Failed to fetch certificates");
//       const data = await res.json();
//       setCertificates(data.data || []);
//     } catch (err) {
//       if (err?.response?.status === 401) {
//         handleSignOut();
//       }
//       console.error("Error fetching certificates:", err);
//     }
//   }, [token, base_url, handleSignOut]);

//   useEffect(() => {
//     fetchCertificates();
//     fetchModules();
//     fetchLearningStats();
//   }, [fetchModules, fetchCertificates, fetchLearningStats]);

//   const pendingCount = modules.filter(
//     (item) => item?.module?.users[0]?.moduleProgress[0]?.status === "in_progress"
//   ).length;

//   const completeCount = modules.filter(
//     (item) => item?.module?.users[0]?.moduleProgress[0]?.status === "completed"
//   ).length;

//   const scores = modules
//     .map(item => item?.module?.users?.[0]?.quizzes?.[0]?.averageScore)
//     .filter(score => typeof score === "number");

//   const overallAverage =
//     scores.length > 0
//       ? scores.reduce((a, b) => a + b, 0) / scores.length
//       : 0;

//   let rtlIconPosition = dir === "rtl" ? 'justify-end' : 'justify-start'
//   let rtlTextPosition = dir === "rtl" ? 'text-end' : 'text-start'
//   let rtlFlexTextPosition = dir === "rtl" ? 'flex-row-reverse' : 'flex-row'

//   function showBgColor(item) {
//     const status = item?.module?.users?.[0]?.moduleProgress?.[0]?.status;
//     switch (status) {
//       case "in_progress":
//         return "bg-[linear-gradient(90deg,rgba(237,221,83,1)_0%,rgba(87,199,133,1)_0%,rgba(69,168,142,1)_66%,rgba(42,123,155,1)_100%)]";
//       case "completed":
//         return "bg-gradient-to-br from-[#A73884] to-[#803A85]";
//       case "not_started":
//         return "bg-[linear-gradient(90deg,rgba(131,58,180,1)_0%,rgba(252,176,69,1)_0%,rgba(253,29,29,1)_100%)]";
//       default:
//         return "";
//     }
//   }

//   const statusPriority = {
//     not_started: 1,
//     in_progress: 2,
//     completed: 3,
//   };

//   const onboardingModules = modules.filter((item) => item?.module?.moduleType === 'onboarding');
//   const onJobModules = modules.filter((item) => item?.module?.moduleType === 'on-job-training');

//   const sortByStatus = (list) =>
//     [...list].sort((a, b) => {
//       const statusA =
//         a?.module?.users?.[0]?.moduleProgress?.[0]?.status || 'not_started';
//       const statusB =
//         b?.module?.users?.[0]?.moduleProgress?.[0]?.status || 'not_started';
//       return statusPriority[statusA] - statusPriority[statusB];
//     });

//   const ModuleCard = (module) => {
//     const item = module.module
//     return (
//       <div
//         key={item.module.id}
//         className="block group cursor-pointer shadow-lg sm:shadow-2xl shadow-gray-300/80"
//         onClick={() =>
//           navigate(`/lms/course?module=${item.module.title}`, { state: { moduleId: item.module.id } })
//         }
//         data-discover="true"
//       >
//         <div className="bg-gradient-to-r from-gray-50 to-white border border-gray-200/50 rounded-xl hover:border-purple-300/50 hover:shadow-lg hover:shadow-purple-200/20 transition-all duration-300 group-hover:scale-[1.02]">
//           <div className="flex flex-col sm:flex-row gap-4">
//             <div className={`w-full sm:w-52 h-40 sm:h-[168px] rounded-l-xl sm:rounded-l-xl flex items-center justify-center flex-shrink-0 shadow-lg group-hover:shadow-purple-300/50 transition-shadow duration-300 ${showBgColor(item)}`}>
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 673.76 360.09" className="opacity-10 w-24 sm:w-auto">
//                 <defs>
//                   <style dangerouslySetInnerHTML={{ __html: ".cls-1{fill:#fff;}" }} />
//                 </defs>
//                 <g id="Layer_2" data-name="Layer 2">
//                   <g id="Layer_1-2" data-name="Layer 1">
//                     <path fill="#F5F5F5" d="M203.41,117l-4.86,24.28L171.87,274.67a31.54,31.54,0,0,1-63.08,0L82.1,141.24,77.25,117a63.08,63.08,0,1,1,126.16,0Z" />
//                     <path fill="#F5F5F5" d="M329.57,243.13a63.08,63.08,0,1,1-126.16,0l4.85-24.28L235,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z" />
//                     <path fill="#F5F5F5" d="M461.05,63.08l-.75,9.84L429.51,328.55a31.54,31.54,0,1,1-63.08,0L335.67,72.92l-.75-9.84a63.07,63.07,0,1,1,126.13,0Z" />
//                     <path fill="#F5F5F5" d="M587.21,243.13a63.08,63.08,0,0,1-126.16,0l4.85-24.28L492.59,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z" />
//                     <circle fill="#F5F5F5" cx="31.54" cy="180.05" r="31.54" />
//                     <circle fill="#F5F5F5" cx="642.22" cy="180.05" r="31.54" />
//                   </g>
//                 </g>
//               </svg>
//             </div>
//             <div className="flex-1 min-w-0 p-4 sm:p-6">
//               <div className="flex items-start justify-between">
//                 <h4 className="font-medium text-gray-900 text-base sm:text-lg group-hover:text-purple-700 transition-colors line-clamp-1">
//                   {item?.module?.title}
//                 </h4>
//                 {item?.module?.users[0]?.moduleProgress[0]?.status === 'completed' && (
//                   <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#8b3580] text-white whitespace-nowrap">
//                     {t('Completed')}
//                   </span>
//                 )}
//                 {item?.module?.users[0]?.moduleProgress[0]?.status === 'in_progress' && (
//                   <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#3389a9] text-white whitespace-nowrap">
//                     {t('In Progress')}
//                   </span>
//                 )}
//                 {item?.module?.users[0]?.moduleProgress[0]?.status === 'not_started' && (
//                   <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#F5F5F5] text-[#212121] whitespace-nowrap">
//                     {t('Not Started')}
//                   </span>
//                 )}
//               </div>
//               <p className="text-gray-600 text-sm mb-3 line-clamp-1">{item?.module?.description}</p>
//               <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-3">
//                 <span className="flex items-center gap-2">
//                   <i className="ri-folder-line text-purple-500" />
//                   {t("Documents")} - {item?.module?.is_show_document ? item?.module?.documents?.length : 0}
//                 </span>
//                 <span className="flex items-center gap-2">
//                   <i className="ri-file-list-line text-purple-500" />
//                   {item.module.quizzes.length > 1
//                     ? `${item?.module?.quizzes?.length} ${t("Quizzes")}`
//                     : `${item?.module?.quizzes?.length} - ${t("Quiz")}`}
//                 </span>
//               </div>
//               <ProgressBar progress={item?.module?.users[0]?.progress_bar || 0} />
//             </div>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   return (
//     <div className={`px-6 lg:px-8 ml-0 ${dir === "rtl" ? "lg:mr-16 mr-0" : "lg:ml-16 ml-0"} space-y-8`}>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//         {loadingModules ? (
//           <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
//         ) : (
//           <div className="lg:col-span-1 sm:col-span-1 group cursor-pointer transform hover:scale-105 transition-all duration-300"
//             style={{ animationDelay: "0ms" }}>
//             <div className="border bg-[#F4F6F8] border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
//               <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("Total Courses")}</p>
//               <div className="flex items-center gap-2">
//                 <div className={`flex items-start ${rtlIconPosition}`}>
//                   <div className="w-12 h-12 rounded-full bg-[#454847] flex items-center justify-center transition-shadow duration-300">
//                     <SvgIcon name="learning" size={30} />
//                   </div>
//                 </div>
//                 <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{modules?.length}</p>
//               </div>
//             </div>
//           </div>
//         )}
//         {loadingModules ? (
//           <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
//         ) : (
//           <div className="lg:col-span-1 sm:col-span-1 group cursor-pointer transform hover:scale-105 transition-all duration-300"
//             style={{ animationDelay: "100ms" }}>
//             <div className="border bg-[#F4F6F8] border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
//               <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("In Progress")}</p>
//               <div className="flex items-center gap-2">
//                 <div className={`flex items-start ${rtlIconPosition}`}>
//                   <div className="w-12 h-12 rounded-full bg-[#26B2C0] flex items-center justify-center transition-shadow duration-300">
//                     <SvgIcon name="progress" size={30} />
//                   </div>
//                 </div>
//                 <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{pendingCount}</p>
//               </div>
//             </div>
//           </div>
//         )}
//         {loadingModules ? (
//           <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
//         ) : (
//           <div className="lg:col-span-1 sm:col-span-1 group cursor-pointer transform hover:scale-105 transition-all duration-300"
//             style={{ animationDelay: "200ms" }}>
//             <div className="border bg-[#F4F6F8] border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
//               <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("Completed")}</p>
//               <div className="flex items-center gap-2">
//                 <div className={`flex items-start ${rtlIconPosition}`}>
//                   <div className="w-12 h-12 rounded-full bg-[#753D87] flex items-center justify-center transition-shadow duration-300">
//                     <SvgIcon name="completed" size={30} />
//                   </div>
//                 </div>
//                 <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{completeCount}</p>
//               </div>
//             </div>
//           </div>
//         )}
//         {loadingModules ? (
//           <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
//         ) : (
//           <div
//             className="group cursor-pointer transform hover:scale-105 transition-all duration-300"
//             style={{ animationDelay: "300ms" }}
//           >
//             <div className="bg-[#F5F5F5] border border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
//               <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("Avg Score")}</p>
//               <div className="flex items-center gap-2">
//                 <div className={`flex items-start ${rtlIconPosition}`}>
//                   <div className="w-12 h-12 rounded-full bg-[#B03B82] flex items-center justify-center transition-shadow duration-300">
//                     <SvgIcon name="average" size={30} />
//                   </div>
//                 </div>
//                 <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{overallAverage.toFixed(2)}%</p>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 mb-8">
//         <div className="lg:col-span-2 bg-[#F4F6F8] backdrop-blur-xl border border-gray-200/50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
//           {loadingModules ? (
//             <SkeletonLoader
//               count={1}
//               className="min-h-[602px] w-full"
//               style={{ borderRadius: '1rem' }}
//             />
//           ) : (
//             <>
//               <div className="px-4 sm:px-6 pt-5">
//                 <div className={`flex items-center justify-between ${rtlFlexTextPosition}`}>
//                   <h3 className="text-lg sm:text-xl font-medium text-gray-900">{t('Recent Courses')}</h3>
//                   <span
//                     className="text-sm text-[#767676] hover:text-purple-777 transition-colors cursor-pointer whitespace-nowrap font-medium"
//                     data-discover="true"
//                     onClick={() => navigate('/lms/all-courses')}
//                   >
//                     {dir === 'rtl' ? (
//                       <>
//                         <i className="ri-arrow-left-line ml-1" />
//                         {t('View All')}
//                       </>
//                     ) : (
//                       <>
//                         {t('View All')}
//                         <i className="ri-arrow-right-line ml-1" />
//                       </>
//                     )}
//                   </span>
//                 </div>
//               </div>
//               <div className="p-4 sm:p-6 space-y-4">
//                 {loadingModules ? (
//                   <div className="text-center text-gray-500 py-6">Loading modules...</div>
//                 ) : modules.length === 0 ? (
//                   <div className="text-center text-gray-500">{t('No modules found')}.</div>
//                 ) : (
//                   <>

//                     {/* {[...modules]
//                       .sort((a, b) => {
//                         const statusA = a?.module?.users?.[0]?.moduleProgress?.[0]?.status || 'not_started';
//                         const statusB = b?.module?.users?.[0]?.moduleProgress?.[0]?.status || 'not_started';
//                         return statusPriority[statusA] - statusPriority[statusB];
//                       })
//                       .slice(0, 4)
//                       .map((item) => (
//                         <div
//                           key={item.module.id}
//                           className="block group cursor-pointer shadow-lg sm:shadow-2xl shadow-gray-300/80"
//                           onClick={() =>
//                             navigate("/lms/dashboard/module", { state: { moduleId: item.module.id } })
//                           }
//                           data-discover="true"
//                         >
//                           <div className="bg-gradient-to-r from-gray-50 to-white border border-gray-200/50 rounded-xl hover:border-purple-300/50 hover:shadow-lg hover:shadow-purple-200/20 transition-all duration-300 group-hover:scale-[1.02]">
//                             <div className="flex flex-col sm:flex-row gap-4">
//                               <div className={`w-full sm:w-52 h-40 sm:h-[168px] rounded-l-xl sm:rounded-l-xl flex items-center justify-center flex-shrink-0 shadow-lg group-hover:shadow-purple-300/50 transition-shadow duration-300 ${showBgColor(item)}`}>
//                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 673.76 360.09" className="opacity-10 w-24 sm:w-auto">
//                                   <defs>
//                                     <style dangerouslySetInnerHTML={{ __html: ".cls-1{fill:#fff;}" }} />
//                                   </defs>
//                                   <g id="Layer_2" data-name="Layer 2">
//                                     <g id="Layer_1-2" data-name="Layer 1">
//                                       <path fill="#F5F5F5" d="M203.41,117l-4.86,24.28L171.87,274.67a31.54,31.54,0,0,1-63.08,0L82.1,141.24,77.25,117a63.08,63.08,0,1,1,126.16,0Z" />
//                                       <path fill="#F5F5F5" d="M329.57,243.13a63.08,63.08,0,1,1-126.16,0l4.85-24.28L235,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z" />
//                                       <path fill="#F5F5F5" d="M461.05,63.08l-.75,9.84L429.51,328.55a31.54,31.54,0,1,1-63.08,0L335.67,72.92l-.75-9.84a63.07,63.07,0,1,1,126.13,0Z" />
//                                       <path fill="#F5F5F5" d="M587.21,243.13a63.08,63.08,0,0,1-126.16,0l4.85-24.28L492.59,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z" />
//                                       <circle fill="#F5F5F5" cx="31.54" cy="180.05" r="31.54" />
//                                       <circle fill="#F5F5F5" cx="642.22" cy="180.05" r="31.54" />
//                                     </g>
//                                   </g>
//                                 </svg>
//                               </div>
//                               <div className="flex-1 min-w-0 p-4 sm:p-6">
//                                 <div className="flex items-start justify-between">
//                                   <h4 className="font-medium text-gray-900 text-base sm:text-lg group-hover:text-purple-700 transition-colors line-clamp-1">
//                                     {item?.module?.title}
//                                   </h4>
//                                   {item?.module?.users[0]?.moduleProgress[0]?.status === 'completed' && (
//                                     <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#8b3580] text-white whitespace-nowrap">
//                                       {t('Completed')}
//                                     </span>
//                                   )}
//                                   {item?.module?.users[0]?.moduleProgress[0]?.status === 'in_progress' && (
//                                     <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#3389a9] text-white whitespace-nowrap">
//                                       {t('In Progress')}
//                                     </span>
//                                   )}
//                                   {item?.module?.users[0]?.moduleProgress[0]?.status === 'not_started' && (
//                                     <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#F5F5F5] text-[#212121] whitespace-nowrap">
//                                       {t('Not Started')}
//                                     </span>
//                                   )}
//                                 </div>
//                                 <p className="text-gray-600 text-sm mb-3 line-clamp-1">{item?.module?.description}</p>
//                                 <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-3">
//                                   <span className="flex items-center gap-2">
//                                     <i className="ri-folder-line text-purple-500" />
//                                     {t("Documents")} - {item?.module?.is_show_document ? item?.module?.documents?.length : 0}
//                                   </span>
//                                   <span className="flex items-center gap-2">
//                                     <i className="ri-file-list-line text-purple-500" />
//                                     {item.module.quizzes.length > 1
//                                       ? `${item?.module?.quizzes?.length} ${t("Quizzes")}`
//                                       : `${item?.module?.quizzes?.length} - ${t("Quiz")}`}
//                                   </span>
//                                 </div>
//                                 <ProgressBar progress={item?.module?.users[0]?.progress_bar || 0} />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))} */}

//                     {onboardingModules.length > 0 && (
//                       <>
//                         <h3 className="text-lg font-bold text-gray-900 mb-8">
//                           <span className="inline-block mr-3 w-1.5 h-6 rounded-full bg-[#B03982]" />{t('On Boarding')}
//                         </h3>
//                         {sortByStatus(onboardingModules)?.slice(0, 2)?.map((item) => <ModuleCard key={item.module.id} module={item} />)}
//                       </>
//                     )}

//                     {onJobModules.length > 0 && (
//                       <>
//                         <h3 className="text-lg font-bold text-gray-900 mb-8">
//                           <span className="inline-block mr-3 w-1.5 h-6 rounded-full bg-[#B03982]" />{t('On Job')}
//                         </h3>
//                         {sortByStatus(onJobModules)?.slice(0, 2)?.map((item) => <ModuleCard key={item.module.id} module={item} />)}
//                       </>
//                     )}

//                   </>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//         <div className="bg-[#F4F6F8] backdrop-blur-xl border border-gray-200/50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
//           {loadingModules ? (
//             <SkeletonLoader count={1} className="min-h-[602px] w-full" style={{ borderRadius: '1rem' }} />
//           ) : (
//             <>
//               <div className="px-4 sm:px-6 py-5 border-gray-200/50">
//                 <h3 className={`text-lg sm:text-xl font-medium text-gray-900 ${rtlTextPosition}`}>{t('Learning Analytics')}</h3>
//               </div>
//               <div className="p-4 sm:p-6 space-y-6 bg-white mx-3 mb-8 rounded-xl shadow-xl">
//                 <div className="space-y-4">
//                   <div className={`flex items-center justify-between ${rtlFlexTextPosition}`}>
//                     <span className="text-gray-600 text-md">{t('Completed')}</span>
//                     <span className="font-medium text-gray-900">{completeCount}</span>
//                   </div>
//                   <div className={`flex items-center justify-between ${rtlFlexTextPosition}`}>
//                     <a href="/lms/userCertificates" className="text-gray-600 text-md">
//                       {t('Certificates')}
//                     </a>
//                     <span className="font-medium text-gray-900">{certificates?.length || 0}</span>
//                   </div>
//                 </div>
//                 <div className="pt-6 border-t border-gray-200/50">
//                   <div className="text-center">
//                     <CircularSegmentProgress progress={overallAverage} size={160} />
//                     <p className="text-gray-600 text-lg mt-8">{t('Overall Progress')}</p>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//       <div className="relative p-6 sm:p-10 lg:p-12 bg-[#F4F6F8] border border-gray-200/50 rounded-2xl">
//         <div className="absolute top-0 left-0">
//           <SvgIcon name="vector" />
//         </div>
//         <div className="max-w-4xl lg:mx-auto text-center sticky z-[1000000]">

//           {/* Title */}
//           <div className="mb-6">
//             <h3 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-[#A73884]">
//               {t('Keep Learning!')}
//             </h3>
//           </div>

//           {/* Description */}
//           <p className="text-[#3d3d3d] text-base sm:text-lg lg:text-xl mb-8 leading-relaxed">
//             {t(`You're doing amazing! Continue your learning journey to unlock more achievements and master new skills.`)}
//           </p>

//           {/* Stats Grid (now 3 cards) */}
//           <div
//             className="
//           grid
//           grid-cols-1
//           sm:grid-cols-2
//           lg:grid-cols-3
//           gap-4
//           sm:gap-6
//           mb-10
//         "
//           >

//             {/* Card: Day Streak */}
//             <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/15 transition-all duration-300">
//               <div className="flex flex-col items-center justify-center pt-8 pb-5 sm:pt-10 rounded-xl bg-white/20 backdrop-blur-sm shadow-lg">
//                 <SvgIcon size={90} name="fire" />
//                 <p className="text-xl sm:text-3xl font-medium text-[#3d3d3d] mt-4">
//                   {learningStats?.metrics?.streak?.count || 0}
//                 </p>
//                 <p className="text-[#3d3d3d]/80 text-xs sm:text-sm font-medium">
//                   {t('Day Streak')}
//                 </p>
//               </div>
//             </div>

//             {/* Card: Ranking */}
//             <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/15 transition-all duration-300">
//               <div className="flex flex-col items-center justify-center pt-8 pb-5 sm:pt-10 rounded-xl bg-white/20 backdrop-blur-sm shadow-lg">
//                 <SvgIcon size={90} name="prize" />
//                 <p className="text-xl sm:text-3xl font-medium text-[#3d3d3d] mt-4">
//                   {t('Top')} {learningStats?.metrics?.ranking?.percentile || 0}%
//                 </p>
//                 <p className="text-[#3d3d3d]/80 text-xs sm:text-sm font-medium">
//                   {t('Ranking')}
//                 </p>
//               </div>
//             </div>

//             {/* Card: Learning Time */}
//             <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/15 transition-all duration-300">
//               <div className="flex flex-col items-center justify-center pt-8 pb-5 sm:pt-10 rounded-xl bg-white/20 backdrop-blur-sm shadow-lg">
//                 <SvgIcon size={90} name="time" />
//                 <p className="text-xl sm:text-3xl font-medium text-[#3d3d3d] mt-4">
//                   {learningStats?.metrics?.learningTime?.formatted || 0}
//                 </p>
//                 <p className="text-[#3d3d3d]/80 text-xs sm:text-sm font-medium">
//                   {t('Learning Time')}
//                 </p>
//               </div>
//             </div>

//           </div>
//         </div>
//         <div className="absolute bottom-0 right-0">
//           <SvgIcon name="vector2" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashboardCourses;

import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { logout } from '../../features/auth/authSlice.js'
import SkeletonLoader from "../../components/skeletonLoader.jsx";
import CircularSegmentProgress from "../../components/circularProgress.jsx";
import SvgIcon from "../../assest/svg/svg.jsx";
import ProgressBar from "../../components/progressBar.jsx";

const DashboardCourses = ({ dir }) => {
  const [learningStats, setLearningStats] = useState(null);
  const [modules, setModules] = useState([]);
  const [loadingModules, setLoadingModules] = useState(true);
  const [certificates, setCertificates] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const base_url = process.env.REACT_APP_LMS_APP_BASE_URL;
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const profileData = JSON.parse(localStorage.getItem("profileData") || sessionStorage.getItem("profileData") || "{}");
  const departmentId = profileData?.department?.id || null;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch()

  // Get sidebar state and handle responsive layout
  useEffect(() => {
    const updateSidebarState = () => {
      const sidebarState = getComputedStyle(document.documentElement).getPropertyValue('--sidebar-open');
      setSidebarOpen(sidebarState === '1');
    };

    updateSidebarState();

    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    const observer = new MutationObserver(updateSidebarState);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleSignOut = useCallback(() => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("profileData");
    sessionStorage.removeItem("conversation");
    sessionStorage.removeItem("currentSessionId");
    sessionStorage.removeItem("sessionNumber");
    sessionStorage.removeItem("sessions");
    dispatch(logout())
    navigate("/login");
  }, [navigate, dispatch]);

  const fetchLearningStats = useCallback(async () => {
    try {
      const response = await axios.get(
        `${base_url}/user/user-stats/dashboard`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data?.data || {};
      setLearningStats(data || {});
    } catch (error) {
      if (error?.response?.status === 401) {
        handleSignOut();
      }
      console.error("Error fetching dashboard data:", error);
    }
  }, [token, base_url, handleSignOut]);

  const fetchModules = useCallback(async () => {
    const moduleTypes = [
      { type: 'onboarding', param: 'onboarding' },
      { type: 'onjobtraining', param: 'on-job-training' },
    ];
    try {
      const requests = moduleTypes.map((item) =>
        axios.get(
          `${base_url}/admin/${item.type}/modules/get-department-modules/${departmentId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { type: item.param },
          }
        )
      );
      const responses = await Promise.all(requests);
      const allModules = responses.flatMap((res) => res.data?.data?.department?.modules || []);
      setModules(allModules);
    } catch (error) {
      if (error?.response?.status === 401) {
        handleSignOut();
      }
      console.error('Error fetching department modules:', error);
    } finally {
      setLoadingModules(false);
    }
  }, [token, departmentId, base_url, handleSignOut]);

  const fetchCertificates = useCallback(async () => {
    try {
      const res = await fetch(`${base_url}/certificate/my-certificates`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) throw new Error("Failed to fetch certificates");
      const data = await res.json();
      setCertificates(data.data || []);
    } catch (err) {
      if (err?.response?.status === 401) {
        handleSignOut();
      }
      console.error("Error fetching certificates:", err);
    }
  }, [token, base_url, handleSignOut]);

  useEffect(() => {
    fetchCertificates();
    fetchModules();
    fetchLearningStats();
  }, [fetchModules, fetchCertificates, fetchLearningStats]);

  const pendingCount = modules.filter(
    (item) => item?.module?.users[0]?.moduleProgress[0]?.status === "in_progress"
  ).length;

  const completeCount = modules.filter(
    (item) => item?.module?.users[0]?.moduleProgress[0]?.status === "completed"
  ).length;

  const scores = modules
    .map(item => item?.module?.users?.[0]?.quizzes?.[0]?.averageScore)
    .filter(score => typeof score === "number");

  const overallAverage =
    scores.length > 0
      ? scores.reduce((a, b) => a + b, 0) / scores.length
      : 0;

  let rtlIconPosition = dir === "rtl" ? 'justify-end' : 'justify-start'
  let rtlTextPosition = dir === "rtl" ? 'text-end' : 'text-start'
  let rtlFlexTextPosition = dir === "rtl" ? 'flex-row-reverse' : 'flex-row'

  // Calculate responsive padding based on sidebar state and screen size
  const getContentPadding = () => {
    if (isMobile) {
      return "";
    }
    return sidebarOpen
      ? (dir === 'rtl' ? 'mr-64' : 'ml-64')
      : (dir === 'rtl' ? 'mr-20' : 'ml-20');
  };

  function showBgColor(item) {
    const status = item?.module?.users?.[0]?.moduleProgress?.[0]?.status;
    switch (status) {
      case "in_progress":
        return "bg-[linear-gradient(90deg,rgba(237,221,83,1)_0%,rgba(87,199,133,1)_0%,rgba(69,168,142,1)_66%,rgba(42,123,155,1)_100%)]";
      case "completed":
        return "bg-gradient-to-br from-[#A73884] to-[#803A85]";
      case "not_started":
        return "bg-[linear-gradient(90deg,rgba(131,58,180,1)_0%,rgba(252,176,69,1)_0%,rgba(253,29,29,1)_100%)]";
      default:
        return "";
    }
  }

  const statusPriority = {
    not_started: 1,
    in_progress: 2,
    completed: 3,
  };

  const onboardingModules = modules.filter((item) => item?.module?.moduleType === 'onboarding');
  const onJobModules = modules.filter((item) => item?.module?.moduleType === 'on-job-training');

  const sortByStatus = (list) =>
    [...list].sort((a, b) => {
      const statusA =
        a?.module?.users?.[0]?.moduleProgress?.[0]?.status || 'not_started';
      const statusB =
        b?.module?.users?.[0]?.moduleProgress?.[0]?.status || 'not_started';
      return statusPriority[statusA] - statusPriority[statusB];
    });

  const ModuleCard = (module) => {
    const item = module.module
    return (
      <div
        key={item.module.id}
        className="block group cursor-pointer shadow-lg sm:shadow-2xl shadow-gray-300/80"
        onClick={() =>
          navigate(`/lms/course?module=${item.module.title}`, { state: { moduleId: item.module.id } })
        }
        data-discover="true"
      >
        <div className="bg-gradient-to-r from-gray-50 to-white border border-gray-200/50 rounded-xl hover:border-purple-300/50 hover:shadow-lg hover:shadow-purple-200/20 transition-all duration-300 group-hover:scale-[1.02]">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className={`w-full sm:w-52 h-40 sm:h-[168px] rounded-l-xl sm:rounded-l-xl flex items-center justify-center flex-shrink-0 shadow-lg group-hover:shadow-purple-300/50 transition-shadow duration-300 ${showBgColor(item)}`}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 673.76 360.09" className="opacity-10 w-24 sm:w-auto">
                <defs>
                  <style dangerouslySetInnerHTML={{ __html: ".cls-1{fill:#fff;}" }} />
                </defs>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path fill="#F5F5F5" d="M203.41,117l-4.86,24.28L171.87,274.67a31.54,31.54,0,0,1-63.08,0L82.1,141.24,77.25,117a63.08,63.08,0,1,1,126.16,0Z" />
                    <path fill="#F5F5F5" d="M329.57,243.13a63.08,63.08,0,1,1-126.16,0l4.85-24.28L235,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z" />
                    <path fill="#F5F5F5" d="M461.05,63.08l-.75,9.84L429.51,328.55a31.54,31.54,0,1,1-63.08,0L335.67,72.92l-.75-9.84a63.07,63.07,0,1,1,126.13,0Z" />
                    <path fill="#F5F5F5" d="M587.21,243.13a63.08,63.08,0,0,1-126.16,0l4.85-24.28L492.59,85.42a31.54,31.54,0,1,1,63.08,0l26.69,133.43Z" />
                    <circle fill="#F5F5F5" cx="31.54" cy="180.05" r="31.54" />
                    <circle fill="#F5F5F5" cx="642.22" cy="180.05" r="31.54" />
                  </g>
                </g>
              </svg>
            </div>
            <div className="flex-1 min-w-0 p-4 sm:p-6">
              <div className="flex items-start justify-between">
                <h4 className="font-medium text-gray-900 text-base sm:text-lg group-hover:text-purple-700 transition-colors line-clamp-1">
                  {item?.module?.title}
                </h4>
                {item?.module?.users[0]?.moduleProgress[0]?.status === 'completed' && (
                  <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#8b3580] text-white whitespace-nowrap">
                    {t('Completed')}
                  </span>
                )}
                {item?.module?.users[0]?.moduleProgress[0]?.status === 'in_progress' && (
                  <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#3389a9] text-white whitespace-nowrap">
                    {t('In Progress')}
                  </span>
                )}
                {item?.module?.users[0]?.moduleProgress[0]?.status === 'not_started' && (
                  <span className="px-4 sm:px-8 py-1 rounded-full text-md sm:text-md font-medium bg-[#F5F5F5] text-[#212121] whitespace-nowrap">
                    {t('Not Started')}
                  </span>
                )}
              </div>
              <p className="text-gray-600 text-sm mb-3 line-clamp-1">{item?.module?.description}</p>
              <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-3">
                <span className="flex items-center gap-2">
                  <i className="ri-folder-line text-purple-500" />
                  {t("Documents")} - {item?.module?.is_show_document ? item?.module?.documents?.length : 0}
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-file-list-line text-purple-500" />
                  {item.module.quizzes.length > 1
                    ? `${item?.module?.quizzes?.length} ${t("Quizzes")}`
                    : `${item?.module?.quizzes?.length} - ${t("Quiz")}`}
                </span>
              </div>
              <ProgressBar progress={item?.module?.users[0]?.progress_bar || 0} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`min-h-[calc(100vh-4rem)] transition-all duration-300 ${getContentPadding()} p-4`}>
      <div className="space-y-8">
        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {loadingModules ? (
            <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
          ) : (
            <div className="group cursor-pointer transform hover:scale-105 transition-all duration-300"
              style={{ animationDelay: "0ms" }}>
              <div className="border bg-[#F4F6F8] border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
                <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("Total Courses")}</p>
                <div className="flex items-center gap-2">
                  <div className={`flex items-start ${rtlIconPosition}`}>
                    <div className="w-12 h-12 rounded-full bg-[#454847] flex items-center justify-center transition-shadow duration-300">
                      <SvgIcon name="learning" size={30} />
                    </div>
                  </div>
                  <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{modules?.length}</p>
                </div>
              </div>
            </div>
          )}
          {loadingModules ? (
            <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
          ) : (
            <div className="group cursor-pointer transform hover:scale-105 transition-all duration-300"
              style={{ animationDelay: "100ms" }}>
              <div className="border bg-[#F4F6F8] border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
                <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("In Progress")}</p>
                <div className="flex items-center gap-2">
                  <div className={`flex items-start ${rtlIconPosition}`}>
                    <div className="w-12 h-12 rounded-full bg-[#26B2C0] flex items-center justify-center transition-shadow duration-300">
                      <SvgIcon name="progress" size={30} />
                    </div>
                  </div>
                  <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{pendingCount}</p>
                </div>
              </div>
            </div>
          )}
          {loadingModules ? (
            <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
          ) : (
            <div className="group cursor-pointer transform hover:scale-105 transition-all duration-300"
              style={{ animationDelay: "200ms" }}>
              <div className="border bg-[#F4F6F8] border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
                <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("Completed")}</p>
                <div className="flex items-center gap-2">
                  <div className={`flex items-start ${rtlIconPosition}`}>
                    <div className="w-12 h-12 rounded-full bg-[#753D87] flex items-center justify-center transition-shadow duration-300">
                      <SvgIcon name="completed" size={30} />
                    </div>
                  </div>
                  <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{completeCount}</p>
                </div>
              </div>
            </div>
          )}
          {loadingModules ? (
            <SkeletonLoader count={1} className="min-h-[162px] w-full" style={{ borderRadius: '1rem' }} />
          ) : (
            <div
              className="group cursor-pointer transform hover:scale-105 transition-all duration-300"
              style={{ animationDelay: "300ms" }}
            >
              <div className="bg-[#F5F5F5] border border-gray-200/50 rounded-2xl p-4 hover:border-gray-300/50 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50">
                <p className={`text-gray-600 text-md mb-2 ${rtlTextPosition}`}>{t("Avg Score")}</p>
                <div className="flex items-center gap-2">
                  <div className={`flex items-start ${rtlIconPosition}`}>
                    <div className="w-12 h-12 rounded-full bg-[#B03B82] flex items-center justify-center transition-shadow duration-300">
                      <SvgIcon name="average" size={30} />
                    </div>
                  </div>
                  <p className={`text-3xl font-medium text-gray-900 ${rtlTextPosition}`}>{overallAverage.toFixed(2)}%</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Main Content Area */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6">
          {/* Recent Courses Section */}
          <div className="lg:col-span-2 bg-[#F4F6F8] backdrop-blur-xl border border-gray-200/50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
            {loadingModules ? (
              <SkeletonLoader
                count={1}
                className="min-h-[602px] w-full"
                style={{ borderRadius: '1rem' }}
              />
            ) : (
              <>
                <div className="px-4 sm:px-6 pt-5">
                  <div className={`flex items-center justify-between ${rtlFlexTextPosition}`}>
                    <h3 className="text-lg sm:text-xl font-medium text-gray-900">{t('Recent Courses')}</h3>
                    <span
                      className="text-sm text-[#767676] hover:text-purple-777 transition-colors cursor-pointer whitespace-nowrap font-medium"
                      data-discover="true"
                      onClick={() => navigate('/lms/all-courses')}
                    >
                      {dir === 'rtl' ? (
                        <>
                          <i className="ri-arrow-left-line ml-1" />
                          {t('View All')}
                        </>
                      ) : (
                        <>
                          {t('View All')}
                          <i className="ri-arrow-right-line ml-1" />
                        </>
                      )}
                    </span>
                  </div>
                </div>
                <div className="p-4 sm:p-6 space-y-4">
                  {loadingModules ? (
                    <div className="text-center text-gray-500 py-6">Loading modules...</div>
                  ) : modules.length === 0 ? (
                    <div className="text-center text-gray-500">{t('No modules found')}.</div>
                  ) : (
                    <>
                      {onboardingModules.length > 0 && (
                        <>
                          <h3 className="text-lg font-bold text-gray-900 mb-8">
                            <span className="inline-block mr-3 w-1.5 h-6 rounded-full bg-[#B03982]" />{t('On Boarding')}
                          </h3>
                          {sortByStatus(onboardingModules)?.slice(0, 2)?.map((item) => <ModuleCard key={item.module.id} module={item} />)}
                        </>
                      )}

                      {onJobModules.length > 0 && (
                        <>
                          <h3 className="text-lg font-bold text-gray-900 mb-8">
                            <span className="inline-block mr-3 w-1.5 h-6 rounded-full bg-[#B03982]" />{t('On Job')}
                          </h3>
                          {sortByStatus(onJobModules)?.slice(0, 2)?.map((item) => <ModuleCard key={item.module.id} module={item} />)}
                        </>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          {/* Analytics Sidebar */}
          <div className="bg-[#F4F6F8] backdrop-blur-xl border border-gray-200/50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
            {loadingModules ? (
              <SkeletonLoader count={1} className="min-h-[602px] w-full" style={{ borderRadius: '1rem' }} />
            ) : (
              <>
                <div className="px-4 sm:px-6 py-5 border-gray-200/50">
                  <h3 className={`text-lg sm:text-xl font-medium text-gray-900 ${rtlTextPosition}`}>{t('Learning Analytics')}</h3>
                </div>
                <div className="p-4 sm:p-6 space-y-6 bg-white mx-3 mb-8 rounded-xl shadow-xl">
                  <div className="space-y-4">
                    <div className={`flex items-center justify-between ${rtlFlexTextPosition}`}>
                      <span className="text-gray-600 text-md">{t('Completed')}</span>
                      <span className="font-medium text-gray-900">{completeCount}</span>
                    </div>
                    <div className={`flex items-center justify-between ${rtlFlexTextPosition}`}>
                      <a href="/lms/userCertificates" className="text-gray-600 text-md">
                        {t('Certificates')}
                      </a>
                      <span className="font-medium text-gray-900">{certificates?.length || 0}</span>
                    </div>
                  </div>
                  <div className="pt-6 border-t border-gray-200/50">
                    <div className="text-center">
                      <CircularSegmentProgress progress={overallAverage} size={160} />
                      <p className="text-gray-600 text-lg mt-8">{t('Overall Progress')}</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Motivation Section */}
        <div className="relative p-6 sm:p-10 lg:p-12 bg-[#F4F6F8] border border-gray-200/50 rounded-2xl">
          <div className="absolute top-0 left-0">
            <SvgIcon name="vector" />
          </div>
          <div className="max-w-4xl lg:mx-auto text-center sticky z-[1000000]">
            <div className="mb-6">
              <h3 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-[#A73884]">
                {t('Keep Learning!')}
              </h3>
            </div>

            <p className="text-[#3d3d3d] text-base sm:text-lg lg:text-xl mb-8 leading-relaxed">
              {t(`You're doing amazing! Continue your learning journey to unlock more achievements and master new skills.`)}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-10">
              {/* Card: Day Streak */}
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/15 transition-all duration-300">
                <div className="flex flex-col items-center justify-center pt-8 pb-5 sm:pt-10 rounded-xl bg-white/20 backdrop-blur-sm shadow-lg">
                  <SvgIcon size={90} name="fire" />
                  <p className="text-xl sm:text-3xl font-medium text-[#3d3d3d] mt-4">
                    {learningStats?.metrics?.streak?.count || 0}
                  </p>
                  <p className="text-[#3d3d3d]/80 text-xs sm:text-sm font-medium">
                    {t('Day Streak')}
                  </p>
                </div>
              </div>

              {/* Card: Ranking */}
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/15 transition-all duration-300">
                <div className="flex flex-col items-center justify-center pt-8 pb-5 sm:pt-10 rounded-xl bg-white/20 backdrop-blur-sm shadow-lg">
                  <SvgIcon size={90} name="prize" />
                  <p className="text-xl sm:text-3xl font-medium text-[#3d3d3d] mt-4">
                    {t('Top')} {learningStats?.metrics?.ranking?.percentile || 0}%
                  </p>
                  <p className="text-[#3d3d3d]/80 text-xs sm:text-sm font-medium">
                    {t('Ranking')}
                  </p>
                </div>
              </div>

              {/* Card: Learning Time */}
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/15 transition-all duration-300">
                <div className="flex flex-col items-center justify-center pt-8 pb-5 sm:pt-10 rounded-xl bg-white/20 backdrop-blur-sm shadow-lg">
                  <SvgIcon size={90} name="time" />
                  <p className="text-xl sm:text-3xl font-medium text-[#3d3d3d] mt-4">
                    {learningStats?.metrics?.learningTime?.formatted || 0}
                  </p>
                  <p className="text-[#3d3d3d]/80 text-xs sm:text-sm font-medium">
                    {t('Learning Time')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 right-0">
            <SvgIcon name="vector2" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCourses;